module.exports = __webpack_public_path__ + "static/media/6.22f37611.jpg";